import { render, staticRenderFns } from "./AddInspiration.vue?vue&type=template&id=0e8b0634&"
import script from "./AddInspiration.vue?vue&type=script&lang=js&"
export * from "./AddInspiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports